const state= {
   notifications:[],
};
export default state



// WEBPACK FOOTER //
// ./src/store/modules/notifications/state.js